import React from 'react';
import {
  ResponsiveContainer,
  AreaChart,
  Area,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip
} from 'recharts';
import { useTheme } from '../../../context/theme-context';

interface SimpleLineChartProps {
  data: any[];
  type: "messages" | "revenue";
}

export const SimpleLineChart: React.FC<SimpleLineChartProps> = ({ data, type }) => {
  const { isDark } = useTheme();
  const dataKey = type === "messages" ? "total" : "revenue";
  const color = type === "messages" ? "#3B82F6" : "#10B981";
  const gridColor = isDark ? "#374151" : "#e5e7eb";
  const axisColor = isDark ? "#9ca3af" : "#6b7280";

  return (
    <div className="h-72 w-full">
      <ResponsiveContainer width="100%" height="100%">
        <AreaChart data={data} margin={{ top: 10, right: 30, left: 0, bottom: 0 }}>
          <defs>
            <linearGradient id="colorFill" x1="0" y1="0" x2="0" y2="1">
              <stop offset="5%" stopColor={color} stopOpacity={0.3} />
              <stop offset="95%" stopColor={color} stopOpacity={0.05} />
            </linearGradient>
          </defs>
          <CartesianGrid strokeDasharray="3 3" stroke={gridColor} />
          <XAxis dataKey="date" stroke={axisColor} tick={{ fill: axisColor }} />
          <YAxis stroke={axisColor} tick={{ fill: axisColor }} />
          <Tooltip
            formatter={(value: number) =>
              type === "revenue" ? `$${value.toLocaleString()}` : value.toLocaleString()
            }
            labelFormatter={(label) => label}
            contentStyle={{
              borderRadius: 8,
              borderColor: isDark ? '#374151' : '#ccc',
              backgroundColor: isDark ? '#1f2937' : '#fff',
              color: isDark ? '#f3f4f6' : '#111827',
            }}
          />
          <Area
            type="monotone"
            dataKey={dataKey}
            stroke={color}
            fillOpacity={1}
            fill="url(#colorFill)"
            strokeWidth={2}
            activeDot={{ r: 5 }}
          />
        </AreaChart>
      </ResponsiveContainer>
    </div>
  );
};
